import $ from "jquery";

$(".leadership-card-more").on( "click", function(e) {
  e.preventDefault();
  $(this).toggleClass("active").siblings(".leadership-card-bio").toggleClass("closed");
  $(this).hasClass("active") ? $(this).html($(this).data("less")) : $(this).html($(this).data("more"));
});
